import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';
import { motion } from 'framer-motion';

import {times, max} from 'lodash';


const RewardBanner = styled(motion.div)`
	position: absolute;
	top: 15vw;
	margin: 0 !important;
	padding: 0;
	height: 100vh;
	z-index: 2000;
	width: 100vw;
`

const Inner = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`

const Rays = styled(motion.img)`
	width: 100vw;
	top: 30vw;
	position: absolute;
`

const Heart = styled(motion.img)`
	width: 10vw;
	position: absolute;
	z-index: 2500;
`
const RewardPanel = styled(motion.div)`
	width: 90vw;
	height: 50vw;
	left: 5vw;
	position: absolute;
	background-size: 100% auto;
	& .xp {
		position: absolute;
		top: 26vw;
		left: 16vw;
		font-size: 10vw;
		color: white;
		text-align: center;
		width: 23vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& > span {
			font-size: 6vw;
		}
	}
	& .trophy {
		position: absolute;
		top: 24vw;
		right: 19vw;
		& > img {
			width: 20vw;
		}
	}
	& .levelstar {
		position: absolute;
		top: 25vw;
		left: 20vw;
		font-size: 6.5vw;
		color: white;
		text-align: center;
		width: 17vw;
		height: 17vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& img {
			position: absolute;
			top: 0;
			left: 0;
			width: 17vw;
		}
		& .number {
			position: absolute;
			top: 5.9vw;
			width: 100%;
			text-align: center;
			left: 0.5vw;
		}
	}
	& .hearts {
		position: absolute;
		top: 25vw;
		left: 53vw;
		font-size: 6.5vw;
		color: white;
		text-align: center;
		width: 17vw;
		height: 17vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& img {
			position: absolute;
			top: 0;
			left: 0;
			width: 17vw;
		}
		& .number {
			position: absolute;
			top: 5.9vw;
			width: 100%;
			text-align: center;
			left: 0.5vw;
			z-index: 10;
		}
	}
`


@observer
export class TopBarLevelUp extends Component {
	sfxPlayed = false;

	componentDidMount(){
		if(!this.sfxPlayed && store.showLevelUpReward[1] > 0) {
			window.manager.playAudio("RewardsPopupStars");
			this.sfxPlayed = true;
		}
	}

	componentDidUpdate(){
		if(!this.sfxPlayed && store.showLevelUpReward[1] > 0) {
			window.manager.playAudio("RewardsPopupStars");
			this.sfxPlayed = true;
		}
	}

	render(){
		var delayBeforeFirstHeart = 1;
		var delayIncrement = 0;

		if(store.showLevelUpReward[1] === 0){
			//something went wrong
			setTimeout(this.props.onHeartsComplete, 2000);
		}

		return (
				<React.Fragment key="levelupf">
				<RewardBanner key="levelup">
					<Inner>
						<Rays alt="" src="/assets/rays.png"
							initial={{rotate: '0deg', scale: 0}}
							exit={{
								rotate: '0deg',
								scale: 0,
								transition: {duration: 0.1, delay: 0}
							}}
							animate={{rotate:'360deg', scale: 1}}
							transition={{
								delay: 0.4,
								rotate: {type: "tween", ease:"linear", duration: 3, loop: Infinity},
								scale: {duration: 0.5}
							}}
						/>
						<RewardPanel
							style={{
								backgroundImage: `url("/assets/languages/${store.settings.language}/levelUpBoxWithBanner.png")`
							}}
							initial={{y: '-80vw'}}
							exit={{
								y: '-80vw',
								transition: {type: 'tween', duration: 0.5}
							}}
							animate={{y: store.aspectIs('Tablet') ? '25vw' : '50vw'}}
							transition={{
								y: {type: "spring", stiffness: 300, damping: 20, mass: 1.5}
							}}
						>
							<Inner>
								<div className="levelstar">
									<Inner>
										<img draggable="false" alt="star icon" src="/assets/hud/hud_icon_star.png"/>
										<div className="number">{store.showLevelUpReward[0]}</div>
									</Inner>
								</div>
								<div className="hearts">
									<Inner>
										<img draggable="false" alt="heart icon" src="/assets/hud/hud_icon_heart.png"/>
										<div className="number">{store.showLevelUpReward[1]}</div>
									</Inner>
								</div>
							</Inner>
						</RewardPanel>
					</Inner>
				</RewardBanner>
				{times(store.showLevelUpReward[1], (n) => {
					var d = max([(0.15 - (n * 0.01)),0.03]);
					delayIncrement += d;
					return (
						<Heart
							onAnimationComplete={n + 1 === store.showLevelUpReward[1] ? this.props.onHeartsComplete : null}
							key={`star-${n}`}
							initial={{x: '62vw', y: store.aspectIs('Tablet') ? '67vw' : '92vw', scale: 0}}
							animate={{x: '74vw', y: '-1vw', scale: [0,1,1,0]}}
							transition={{
								default: {delay: delayBeforeFirstHeart + delayIncrement, duration: 0.8, ease: 'easeInOut'}
							}}
							src="/assets/hud/hud_icon_heart.png"
						/>
					);
				})}
			</React.Fragment>
		)
	}
}
